import C from "@/modules/billing/choose_method/ChooseMethod.module.css";

import { type BaseProps, mcn } from "@/utils/baseProps.ts";
import type { ReactNode } from "react";

/** Wrapper visual box around payment forms */
export function FormBox({ children, ...baseProps }: { children: ReactNode } & BaseProps) {
    return <div {...mcn(C.Content, baseProps)}>{children}</div>;
}
